var widget_default = {
  "card": "xaQs-",
  "link": "mGaNO",
  "container": "kcVqG",
  "image": "re1sU",
  "right": "STVbl",
  "cardLayout": "iy3aj",
  "content": "yGVUA",
  "title": "Ob0xh",
  "subtitle": "k9Z2A",
  "button": "b2GAX",
  "button_disabled": "HVA5G",
  "buttonText": "i-qRC",
  "slimLayout": "WYHH-",
  "contentText": "EvvPR"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
